import { createApi } from "@reduxjs/toolkit/query/react";

import { Device } from "../../../types";
import axiosBaseQuery from "../rtk-query-axios.service";
import { APP_BASE_URL, GET_ASSETS } from "../../../Common/EndPoints";

type DeviceParams = {
  params: {
    deviceTypeIds?: string;
    customerIds?: string;
  };
};

export const deviceApi = createApi({
  reducerPath: "deviceAPI",
  baseQuery: axiosBaseQuery,
  tagTypes: ["device-list"],
  endpoints: (builder) => ({
    getDevices: builder.query<Device[], void | DeviceParams>({
      query: ({ params }: DeviceParams) => ({
        url: APP_BASE_URL + GET_ASSETS,
        method: "GET",
        params,
      }),
      providesTags: ["device-list"],
      transformResponse: (_response: { error: any; success: any; data: Device[] }): Device[] => _response.data,
    }),
  }),
});
